export default function NotifyBoBean() {
    this.noId = 0
    this.noTitle = ''
    this.noStatu = ''
    this.noContent = ''
    this.noIssue = ''
    this.noTime = ''
    this.enclosure = []
    this.receiveList = []
    this.unRead = 0
    this.readed = 0
    this.allCount = 0
}